export const FETCH_ALL_MEMBERSHIPS = 'api/FETCH_ALL_MEMBERSHIPS'
export const FETCH_ALL_MEMBERSHIPS_SUCCESS = 'api/FETCH_ALL_MEMBERSHIPS_SUCCESS'
export const FETCH_ALL_MEMBERSHIPS_ERROR = 'api/FETCH_ALL_MEMBERSHIPS_ERROR'

export const HYDRATE_MEMBERSHIPS_SUCCEEDED = 'api/HYDRATE_MEMBERSHIPS_SUCCEEDED'
